import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        sites: '=',
        classifiers: '=',
        filter: '=',
        defaultFilter: '=',
        list1: '=',
        list2: '=',
        list3: '=',
        loading1: '=',
        loading2: '=',
        loading3: '=',
        selectedRange: '='
    },
    template: `
        <div class="block02" ng-class="{ open: vm.filters === true }" ng-if="vm.view !== 'modal'">
            <div class="heading01 theme01">
                <h3 ng-click="vm.changeFilter()">{{ 'filter.Filters' | translate }}</h3>
            </div>
            <div class="table-filters animated-fade" ng-class="{ 'open': vm.filters }" ng-if="vm.filters && !vm.loading">
                <form class="form form-filter type02" ng-submit="vm.applyFilter()">
                    <div class="fields">

                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.From' | translate }}</label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.from"></datepicker-api>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.To' | translate }}</label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.to"></datepicker-api>
                            </div>
                        </div>
                        <div class="row row-flex02 row-separated">
                            <label class="label">{{ 'filter.Site' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.siteFilter.options"
                                    selected-model="vm.siteFilter.model"
                                    extra-settings="vm.siteFilter.settings"
                                    translation-texts="vm.filterTranslations"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Department' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.departmentSelect.options"
                                    selected-model="vm.FilterService.departmentSelect.models"
                                    extra-settings="vm.FilterService.departmentSelect.settings"
                                    events="vm.FilterService.departmentSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Role' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.roleSelect.options"
                                    selected-model="vm.FilterService.roleSelect.models"
                                    extra-settings="vm.FilterService.roleSelect.settings"
                                    events="vm.FilterService.roleSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Level' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.levelSelect.options"
                                    selected-model="vm.FilterService.levelSelect.models"
                                    extra-settings="vm.FilterService.levelSelect.settings"
                                    events="vm.FilterService.levelSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                        <div ng-if="vm.isOptionalCoursesEnabled" class="row row-flex02">
                            <label class="label">{{ 'filter.Participation' | translate }}</label>
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.participationFilter.options"
                                    selected-model="vm.participationFilter.model"
                                    extra-settings="vm.participationFilter.settings"
                                    translation-texts="vm.filterTranslations">
                                ></div>
                            </div>
                        </div>
                        <div class="row row-flex02">
                            <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                            <div class="items">
                                <autocomplete
                                    label-attribute="'displayName'"
                                    selected-item="vm.selectedEmployee"
                                    ng-model="vm.filter.directManagerId"
                                    value-attribute="'id'"
                                    query="vm.queryUsers(input)"
                                />
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Generate report' | translate }}"></li>
                    </ul>
                </form>
            </div>
        </div>
        <style>
        .animated-fade {
            opacity: 0;
            max-height: 0;
            transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;
        }

        .animated-fade.open {
            opacity: 1;
            max-height: 500px; /* Adjust based on content */
        }
        </style>
    `
})
export default class {
    constructor ($translate, lodash, CLASSIFIER_ENUM, ROLE_CODE_ENUM, COURSE_STATUS_TYPE_ENUM, COURSE_TARGET_NEED_TYPE_ENUM, ClassifierResource, SiteResource,
                 MomentService, PrivilegeService, SiteService, StringService, TokenService, FilterService, USER_STATUS_ENUM, $window, $rootScope, $scope,
                 $timeout, UserResource, toastr) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.StringService = StringService;
        this.FilterService = FilterService;
        this.ClassifierResource = ClassifierResource;
        this.SiteResource = SiteResource;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.UserResource = UserResource;
        this.toastr = toastr;

        const userId = this.TokenService.getUser().id;
        this.loading = true;
        this.isOptionalCoursesEnabled = this.TokenService.isOptionalCoursesModuleEnabled();
        this.filters = JSON.parse(this.$window.localStorage.getItem(`${userId}_is_report_overview_filter_opened`));

        $scope.$on('overviewReport:classifiersLoaded', () => {
            $timeout(() => {
                this.loading = false;
                this.initFilters();
            }, 100);
        });
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            'siteIds[]': this.sites.map(site => site.id),
            name: input,
            pageSize: 0
        };
        return this.UserResource.query(params).$promise;
    }

    initFilters () {
        this.departments = this.classifiers.filter(c => c.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter(c => c.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter(c => c.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.filterTranslations = this.FilterService.getTranslations();

        // Ensure filters are open with animation
        this.$timeout(() => {
            this.filters = true;
        }, 100);
    }

    changeFilter () {
        this.filters = !this.filters;
        const userId = this.TokenService.getUser().id;
        this.$window.localStorage.setItem(`${userId}_is_report_overview_filter_opened`, this.filters);
    }

    applyFilter () {
        this.filter.siteIds = this.siteFilter.model.map(site => site.value);

        this.filter.departmentIds = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter.roleIds = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter.levelIds = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        this.filter.participationTypes = this.participationFilter.model.map(participation => participation.value);

        this.selectedRange = null;

        this.loadReports();
    }

    loadReports () {
        this.loading1 = true;
        this.loading2 = true;
        this.loading3 = true;

        const displayedErrors = new Set(); // Store unique error messages

        this.list1.fetch({}, this.filter).then(() => {
            this.loading1 = false;
        }).catch((response) => {
            const errorMessage = response.data[0].message;
            if (!displayedErrors.has(errorMessage)) {
                this.toastr.error(errorMessage);
                displayedErrors.add(errorMessage);
            }
            this.loading1 = false;
        });

        this.list2.fetch({}, this.filter).then(() => {
            this.loading2 = false;
        }).catch((response) => {
            const errorMessage = response.data[0].message;
            if (!displayedErrors.has(errorMessage)) {
                this.toastr.error(errorMessage);
                displayedErrors.add(errorMessage);
            }
            this.loading2 = false;
        });

        this.list3.fetch({}, this.filter).then(() => {
            this.loading3 = false;
        }).catch((response) => {
            const errorMessage = response.data[0].message;
            if (!displayedErrors.has(errorMessage)) {
                this.toastr.error(errorMessage);
                displayedErrors.add(errorMessage);
            }
            this.loading3 = false;
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.siteFilter = angular.copy(this.defaultSiteFilter);
        this.FilterService.initClassifierMultiFilter();

        if (this.isOptionalCoursesEnabled) {
            this.participationFilter = angular.copy(this.defaultParticipationFilter);
        }
        this.selectedEmployee = null;

        this.applyFilter();
    }


    initFilters () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = [...siteOptions];

        this.siteFilter = {
            model: siteOptionsSelected,
            options: siteOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => itemText
            }
        };

        const participationOptions = [
            { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.COMPULSORY },
            { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.OPTIONAL }
        ];
        const participationOptionsSelected = [...participationOptions];

        this.participationFilter = {
            model: participationOptionsSelected,
            options: participationOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => {
                    return itemText;
                }
            }
        };

        this.defaultParticipationFilter = angular.copy(this.participationFilter);

        // this are used when filter is reset
        this.defaultSiteFilter = angular.copy(this.siteFilter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/overview/filter/index.js